import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'groupBy',
})
export class GroupByPipe implements PipeTransform {
    transform(collection: Array<any>, property: string): any {
        return _.groupBy(collection, property);
    }
}
